<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>
<div mat-dialog-title class="matDialogTitle" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <span>
        <span>{{ title }}</span>
    </span>
    <span (click)="close()">
        <mat-icon class="close">close</mat-icon>
    </span>
</div>

<form [formGroup]="form1_group" (ngSubmit)="check_access(type_task,1)">
    <div mat-dialog-content class="matDialogContent">
        <div class="row pe1">
            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> نام و نام خانوادگی : </span>
                    <span *ngIf="lang == 2"> Title : </span>
                    <input class='wh-input' formControlName="title" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> نام شعبه : </span>
                    <span *ngIf="lang == 2"> Branch title : </span>
                    <input class='wh-input' formControlName="branch_title" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> کد شعبه : </span>
                    <span *ngIf="lang == 2"> Branch Code : </span>
                    <input class='wh-input' formControlName="branch_code" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> شماره حساب: </span>
                    <span *ngIf="lang == 2"> Account number : </span>
                    <input class='wh-input' formControlName="number" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> شماره کارت : </span>
                    <span *ngIf="lang == 2"> Cart Number : </span>
                    <input class='wh-input' formControlName="cart" autocomplete="off">
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> شماره شبا: </span>
                    <span *ngIf="lang == 2"> Sheba number : </span>
                    <div>
                        <span style="float:left;padding-top:9px">IR</span>
                        <input class='wh-input' formControlName="sheba" autocomplete="off" style="width:93%">
                    </div>
                </label>
            </div>

            <div class='col-xl-4 col-lg-4 col-md-4 col-sm-4 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="status_id" class='wh-label'>
                    <span *ngIf="lang == 1"> وضعیت : </span>
                    <span *ngIf="lang == 2"> Status : </span>
                    <span (click)="reset_input(26)">
                        <mat-icon class="close" class="input_search input_search_pe"
                            [ngClass]="{input_search_en:lang==2}">close</mat-icon>
                    </span>
                    <input class="wh-input" formControlName="status_title" (click)="load_services(26) "
                        [required]="required()" readonly>
                    <input class="wh-input" formControlName="status_id" [hidden]="true" [required]="required()"
                        readonly>
                </label>
            </div>

            <div class='col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe div_panding' [ngClass]="{en:lang==2}">
                <label for="title" class='wh-label'>
                    <span *ngIf="lang == 1"> آدرس: </span>
                    <span *ngIf="lang == 2"> Address : </span>
                    <div>
                        <input class='wh-input' formControlName="branch_address" autocomplete="off">
                    </div>
                </label>
            </div>

        </div>
    </div>

    <div mat-dialog-actions class="matDialogActions">
        <button type="submit" [disabled]="!form1_group.valid" class="btn_pe" [ngClass]="{btn_en:lang == 2}"
            *ngIf="type_task == 1 || type_task == 2">
            <span *ngIf="lang == 2">Save</span>
            <span *ngIf="lang == 1">ذخیره</span>
        </button>
        <button type="submit" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3">
            <span *ngIf="lang == 2">Search</span>
            <span *ngIf="lang == 1">جستجو</span>
        </button>
        <button type="button" class="btn_pe" [ngClass]="{btn_en:lang == 2}" *ngIf="type_task == 3"
            (click)="check_access(type_task,2)">
            <span *ngIf="lang == 2">Excel</span>
            <span *ngIf="lang == 1">خروجی اکسل</span>
        </button>
    </div>
</form>